import { CircularProgress } from "@suraasa/placebo-ui"

type Props = {
  /**
   * if true renders `Suraasa Butterfly` instead of `CircularProgress`
   */
  showLogo?: boolean
  children?: React.ReactNode
}

const LoadingOverlay: React.FC<Props> = ({ children, showLogo = false }) => {
  return (
    <div
      className={
        "absolute left-0 top-0 z-[theme(zIndex.dialog)] flex size-full flex-col items-center justify-center rounded-lg bg-white"
      }
    >
      {showLogo ? (
        <img
          src="https://assets.suraasa.com/logos/v2/learning-operations.webp"
          fetchPriority="high"
          alt=""
          height={70}
          width={70}
        />
      ) : (
        <CircularProgress size="md" />
      )}
      {children}
    </div>
  )
}

export default LoadingOverlay
